import React from "react";
import revampData from "../../data/revampData.json";
import { useRouter } from "next/router";
import { useIsMobile } from "../../config/customHooks";

interface PartnerButton {
	url: string;
	text: string;
}

interface BecomePartnerData {
	title: string;
	description: string;
	backgroundImage: string;
	mobileBackgroundImage: string;
	button: PartnerButton;
}

const BecomePartner: React.FC = () => {
	const isMobile = useIsMobile(576); // Note: pass as number, not string
	const router = useRouter();

	// Safely extract and cast the data
	const data: any = revampData?.data?.listMarathonBecomeAPartner?.data?.[0] as any;

	return (
		<div className="my-5">
			{/* Make the section full-bleed by removing the auto horizontal margin and using width:100% */}
			<section
				className="relative d-flex align-items-xl-center bg-cover bg-center bg-no-repeat text-white pt-3 pb-2 px-4 text-center full-bleed-hero"
				style={{
					backgroundImage: `url('${
						isMobile
							? encodeURI(data.mobileBackgroundImage)
							: encodeURI(data.backgroundImage)
					}')`,
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
					height: isMobile ? "440px" : "420px",
					backgroundSize: "cover",
					width: "100%"
				}}
			>
				<div className="absolute inset-0 bg-black bg-opacity-50"></div>
				<div className="relative z-10 max-w-3xl mx-auto become-a-partner-max-width py-4 d-flex justify-content-center flex-column gap-1">
					<p className="text-3xl become-a-partner-title mb-4">Endure. Conquer. Repeat.</p>
				</div>
			</section>
			<style jsx>{`
				.become-a-partner-max-width {
					max-width: 990px;
				}
				.become-a-partner-title {
					font-size: 64px;
					font-weight: 400;
				}
				.become-partnership-btn {
					max-width: 225px;
					width: 100%;
					font-size: 16px;
					font-weight: 700;
					border-radius: 5px;
					border: 1px solid #ffffff;
					margin: 0 auto;
				}
				@media (max-width: 992px) {
					.become-partner-margin {
						margin-bottom: 10px !important;
					}
				}
				@media (max-width: 990px) {
					.become-a-partner-title {
						font-size: 23px;
						font-weight: 600;
					}
				}
				@media (max-width: 390px) {
					.become-a-partner-title {
						font-size: 21px;
						font-weight: 600;
					}
				}
			`}</style>
		</div>
	);
};

export default BecomePartner;
